<template>
    <b-modal id="modal_conta"
                ref="modal_conta"
                size="lg"
                :title="modal_titulo"
                :ok-title="modal_botao"
                close-title="Fechar"
                :ok-disabled=form.errors.any()
                v-model="showModal"
                @ok="handleOk">
    <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
        <b-container fluid class="p-a-0">
            <b-row>
                <b-col>
                    <label>Descrição</label>
                    <b-form-input type="text"
                                    placeholder="Descrição"
                                    v-model="form.descr"
                                    >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="p-l-0">
                    <label>Agencia</label>
                    <b-form-input type="text"
                                placeholder="Agencia"
                                v-model="form.agencia"
                                >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('agencia')" v-if="form.errors.has('agencia')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label>Agencia Digito</label>
                    <b-form-input type="text"
                                placeholder="Agencia Digito"
                                v-model="form.agencia_dig"
                                >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('agencia_dig')" v-if="form.errors.has('agencia_dig')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label>Conta</label>
                    <b-form-input type="text"
                                placeholder="Conta"
                                v-model="form.conta"
                                >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('conta')" v-if="form.errors.has('conta')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label>Conta Digito</label>
                    <b-form-input type="text"
                                placeholder="Conta Digito"
                                v-model="form.conta_dig"
                                >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('conta_dig')" v-if="form.errors.has('conta_dig')"></b-form-feedback>
                </b-col>

            </b-row>
            <b-row>
                <b-col class="p-l-0" v-if="modal_acao=='i'">
                    <label>Saldo Inicial</label>
                    <currency-input
                    class="form-control"
                    v-model="form.vlr"
                    :auto-decimal-mode="true"
                    placeholder="Saldo Inicial"
                    :currency="{ prefix: ''}"
                    :distraction-free="getCurrency"/>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('vlr')" v-if="form.errors.has('vlr')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Banco</label>
                    <multiselect v-model="bancoSelected"
                        :options="this.optionsParamBanco"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('parban_id.value')" v-if="form.errors.has('parban_id.value')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label>Principal</label>
                    <multiselect v-model="principalSelected"
                    :options="this.optionsLivPrincipal"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('principal.value')" v-if="form.errors.has('principal.value')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label>Status</label>
                    <multiselect v-model="statusSelected"
                    :options="this.optionsLivStatusDoc"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>
                </b-col>

            </b-row>
        </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <b-btn @click="showModal=false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                    Enviar
                </b-btn>
            </div>
    </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'
import moment from 'moment'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        statusSelected: [],
        bancoSelected: [],
        principalSelected: [],
        optionsLivStatusDoc: [],
        optionsLivPrincipal: [],
        optionsParamBanco:  [],
        errors_array: [],
        helpForm: new Form({
            statusRecord: [],
            params: []
        }),
        form: new Form({
            descr: '',
            status: '',
            parban_id: '',
            unidade_id: '',
            unicon_id: '',
            agencia: '',
            agencia_dig: '',
            conta: '',
            conta_dig: '',
            principal: '',
            vlr: ''
        }),
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    statusSelected(obj){
        this.form.status = obj.value;
    },
    bancoSelected(obj){
        this.form.parban_id = obj.value;
    },
    principalSelected(obj){
        this.form.principal = obj.value;
    }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.unicon_id);
        }
    },
    onCreate(data) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar conta";
        this.modal_botao = "Cadastrar conta";
        this.modal_acao = "i";
        this.form.reset();
        this.optionsLivStatusDoc = this.$parent.optionsLivStatusDoc;
        this.optionsLivPrincipal = this.$parent.optionsLivPrincipal;
        this.optionsParamBanco = this.$parent.optionsParamBanco;
        this.statusSelected = [];
        this.principalSelected = [];
        this.bancoSelected = [];
        this.form.unidade_id = data.unidade_id;
        this.$refs.modal_conta.show();
    },
    onEdit (data, index) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar Conta";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.optionsLivStatusDoc = this.$parent.$parent.$parent.optionsLivStatusDoc;
        this.optionsLivPrincipal = this.$parent.$parent.$parent.optionsLivPrincipal;
        this.optionsParamBanco = this.$parent.$parent.$parent.optionsParamBanco;
        this.form.descr = data.descr;
        this.form.agencia = data.agencia;
        this.form.agencia_dig = data.agencia_dig;
        this.form.conta = data.conta;
        this.form.conta_dig = data.conta_dig;
        this.form.unicon_id = data.unicon_id;
        this.form.unidade_id = data.unidade_id;
        this.principalSelected   = { label: data.principal.descr, value: data.principal.valor };
        this.bancoSelected = { label: data.param_banco.descr, value: data.param_banco.parban_id};
        this.statusSelected   = { label: data.status.descr, value: data.status.valor };
        this.$refs.modal_conta.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/unidade/conta/store').then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/unidade/conta/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
<style>
#modal_conta .modal-lg{
    max-width: 60% !important;
}
</style>
